import { AnyAction } from 'redux'
import { Actions } from '../actions/most-urgent-activities'
import { MostUrgentActivitiesState } from '../states/mostUrgentActivitiesState'

export const MOST_URGENT_ACTIVITIES_REDUCER_NAMESPACE = 'mostUrgentActivitiesReducer'

const defaultState: MostUrgentActivitiesState = {
    activities: [],
    loading: true,
    filters: {
        page: 1,
        page_size: 5,
        tab: 'to_me',
        type: {
            value: ['task'],
        },
        priority: {
            value: ['urgent'],
        },
        status: {
            value: [
                'toBeReleased',
                'released',
                'new',
                'inProgress',
                'read',
                'inApproval',
                'overdue',
                'redo',
            ],
        },
    },
}

export default (state: MostUrgentActivitiesState = defaultState, action: AnyAction) => {
    switch (action.type) {
        case Actions.GET_MOST_URGENT_ACTIVITIES_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case Actions.GET_MOST_URGENT_ACTIVITIES_SUCCESS:
            return {
                ...state,
                activities: action.activities,
                loading: false,
            }
        case Actions.GET_MOST_URGENT_ACTIVITIES_FAILURE:
            return {
                ...state,
                loading: false,
            }
        default:
            return state
    }
}
